export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-en-5034c79b1174d2ba5f096f2d62a7d9f3.webp";